<template>
  <div class="main-background">
    <div class="noresult-screen-full">
      <button class="main-back-button" aria-label="На головну магазину" @click="goToMainPage">
        <chevron-left-icon class="main-back-button-icon" />
      </button>
      <product-search ref="searchInput" v-model="searchLocalText" :categories="allCategories"
        @input="onSearchInput" @search="activeProductSearch" @product="setClickToProduct" @category="selectSearchCategory" />
      <div class="search-filter">
        <div v-if="isShowProducts !== 'products'" class="search-filter-btn">
          <button class="filter-button" aria-label="Відкрити фільтри" @click="setIsOpenFilterPage">
            <sliders-icon class="filter-button-icon" />
          </button>
        </div>
      </div>
    </div>

    <div v-if="isShowProducts !== 'category'" class="filter-category-list">
      <div
        class="filter-category-item"
        :style="[
          usedCategories.id === category.id && {
            background: '#333',
            color: '#fff',
          },
        ]"
        @click="setClickToHeaderCategory(category)"
        v-for="category of allCategories"
        :key="category.id"
      >
        {{ category.name }}
      </div>
    </div>
    <p v-if="searchLocalText" class="product-used-title">
      {{ `Результат пошуку "${searchLocalText}"` }}
    </p>
    <div v-if="isShowProducts === 'products'" class="sort-filter-container">
      <button class="small-filter-button" @click="setIsOpenFilterPage">
        <sliders-icon class="small-filter-button-icon" />
        Фільтр
        <span
          v-if="filterChips.length"
          class="used-filter-length"
          >{{ `(+${getFilterCounter(getFilterParametrs)})` }}</span
        >
      </button>
      <div class="main-sort-container">
        <button type="button" class="product-sort-list-button" :aria-expanded="isOpenSortList ? 'true' : 'false'" @click="setIsOpenSortList">
          {{ usedSort ? usedSort : "Сортувати за" }}
          <chevron-down-icon class="sort-button-icon" aria-hidden="true" />
        </button>
        <div v-if="isOpenSortList" class="sort-items-container">
          <button type="button"
            class="sort-items"
            v-for="list of sortList"
            :key="list.id"
            @click="isStartSort(list)"
          >
            {{ list.name }}
          </button>
        </div>
      </div>
    </div>
    <div v-if="isShowProducts === 'products'" class="applied-filters">
      <button v-for="chip in filterChips" :key="chip.key" type="button" class="filter-chip" :aria-label="'Прибрати фільтр: ' + chip.label" @click="removeFilter(chip)">{{ chip.label }} ×</button>
      <button v-if="filterChips.length" type="button" class="filter-chip" @click="resetFilters">Скинути всі</button>
      <p v-if="!productsLoading && !productsError && $store.getters.productsTotal !== null" class="results-total" role="status">Знайдено {{ countText($store.getters.productsTotal) }}</p>
    </div>
    <request-state v-if="isShowProducts !== 'products'" :loading="$store.getters.resources.categories.loading" :error="$store.getters.resources.categories.error" loading-text="Завантажуємо категорії…" @retry="$store.dispatch('allCategories')" />
    <h2 v-if="isShowProducts === 'category'" class="category-used-title">
      Категорії
    </h2>
    <div v-if="isShowProducts === 'category' && !productsLoading && !productsError" class="category-container">
      <div
        v-for="category of allCategories"
        :key="category.id"
        class="category-block"
        @click="setClickToCategory(category)"
      >
        <img v-lazy="category.img" :alt="category.name" class="categoty-image" />
        <div class="categoty-name-container">
          <p class="categoty-name">{{ category.name }}</p>
        </div>
      </div>
    </div>
    <h2 v-if="isShowProducts === 'preCategory'" class="category-used-title">
      {{ usedCategories.name }}
    </h2>
    <div v-if="isShowProducts === 'preCategory' && !productsLoading && !productsError" class="category-container">
      <div
        v-for="category of preCategories.children || preCategories"
        :key="category.id"
        class="category-block"
        @click="setClickToPreCategories(category)"
      >
        <img v-lazy="category.img" :alt="category.name" class="categoty-image" />
        <div class="categoty-name-container">
          <p class="categoty-name">{{ category.name }}</p>
        </div>
      </div>
    </div>
    <p v-if="productsLoading" class="search-empty-state" role="status">Завантажуємо товари…</p>
    <div v-else-if="productsError" class="search-empty-state" role="alert">
      <p>{{ productsError }}</p>
      <button type="button" class="search-empty-button" @click="retryProducts">Спробувати ще раз</button>
    </div>
    <div v-else-if="isShowProducts === 'products' && !products.length" class="search-empty-state" role="status">
      <h2>Нічого не знайшли</h2>
      <p>Спробуйте змінити запит або скинути фільтри.</p>
      <button type="button" class="search-empty-button" @click="editSearch">Змінити запит</button>
      <button v-if="hasFilters" type="button" class="search-empty-button" @click="resetFilters">Скинути фільтри</button>
      <button type="button" class="search-empty-button" @click="showCategories">Перейти до категорій</button>
    </div>
    <div v-else-if="isShowProducts === 'products'" class="category-container">
      <div
        v-for="product of products"
        :key="product.id"
        class="product-block"
        @click="setClickToProduct(product)"
      >
        <span v-if="discountOf(product)" class="card-discount-badge"
          >−{{ discountOf(product) }}%</span
        >
        <img v-lazy="product.img" :alt="product.name" class="product-image" />
        <div class="product-name-container">
          <button type="button" class="product-name product-open-button" @click.stop="setClickToProduct(product)">{{ product.name }}</button>
          <product-price :price="product.price" :old-price="product.price_old" />
          <product-availability :product="product" />
          <favorite-button :product="product" />
        </div>
        <product-cart-control :product="product" />
      </div>
    </div>
    <nav v-if="isShowProducts === 'products' && !productsLoading && !productsError && $store.getters.productsLastPage > 1" class="pagination" aria-label="Сторінки товарів">
      <button type="button" :disabled="$store.getters.productsPage <= 1" @click="loadPage(-1)">Назад</button>
      <span>{{ $store.getters.productsPage }} / {{ $store.getters.productsLastPage }}</span>
      <button type="button" :disabled="$store.getters.productsPage >= $store.getters.productsLastPage" @click="loadPage(1)">Далі</button>
    </nav>
  </div>
</template>

<script>
import ProductAvailability from '../../../components/ProductAvailability.vue';
import FavoriteButton from '../../../components/FavoriteButton.vue';
import { productCount } from '../helpers/productCount';
import { SlidersIcon, ChevronDownIcon } from "vue-feather-icons";
import ProductSearch from '../../../components/ProductSearch.vue';
import { mapMutations } from "vuex";
import { ChevronLeftIcon } from "vue-feather-icons";
import ProductCartControl from "../../../components/ProductCartControl.vue";
import ProductPrice from "../../../components/ProductPrice.vue";
import RequestState from "../../../components/RequestState.vue";

export default {
  name: "product-page",
  components: { ProductAvailability, FavoriteButton,
    SlidersIcon,
    ProductSearch,
    ChevronDownIcon,
    ChevronLeftIcon,
    ProductCartControl,
    ProductPrice,
    RequestState,
  },
  props: {},
  data() {
    return {
      usedCategories: {},
      categoryItems: [],
      productItemsElements: [],
      searchLocalText: "",
      isOpenSortList: false,
      usedSort: "",
      sortList: [
        { id: 1, name: "А-Я", value: "name" },
        { id: 2, name: "Я-А", value: "-name" },
        { id: 3, name: "Зростанням ціни", value: "price" },
        { id: 4, name: "Спаданням ціни", value: "-price" },
      ],
    };
  },
  async mounted() {
    console.log('Product page opened');
    window.scrollTo(0, 0);
    this.searchLocalText = this.getSearchText;
    if (this.searchLocalText) {
      this.$nextTick(() => this.$refs.searchInput.focus());
    }
  },
  computed: {
    filterChips() {
      const filters = this.getFilterParametrs;
      const names = new Map();
      const visit = categories => (categories || []).forEach(category => { names.set(String(category.id), category.name); visit(category.children); });
      visit(this.allCategories);
      const chips = (filters.category_ids || []).map(id => ({ key: 'category-' + id, id, label: names.get(String(id)) || 'Категорія ' + id }));
      if (filters.price_from != null || filters.price_to != null) chips.push({ key: 'price', label: `${filters.price_from ?? 0}–${filters.price_to} грн` });
      return chips;
    },
    products() {
      const products = this.getProducts?.products || this.getProducts;
      return Array.isArray(products) ? products : [];
    },
    productsLoading() { return this.$store.getters.productsLoading; },
    productsError() { return this.$store.getters.productsError; },
    hasFilters() {
      const filters = this.getFilterParametrs || {};
      return Boolean(filters.category_ids?.length || filters.price_from || filters.price_to || this.getCheckedCategory?.id);
    },
    allCategories() {
      return this.$store.getters.allCategories;
    },
    isShowProducts() {
      return this.$store.getters.isShowProducts;
    },
    preCategories() {
      return this.$store.getters.preCategories;
    },
    getProducts() {
      return this.$store.getters.getProducts;
    },
    getSearchText() {
      return this.$store.getters.getSearchText;
    },
    getFilterParametrs() {
      return this.$store.getters.getFilterParametrs;
    },
    getCheckedCategory() {
      return this.$store.getters.getCheckedCategory;
    },
  },
  methods: {
    onSearchInput(value) {
      if (value) return;
      if (!this.hasFilters) {
        this.cancelProductsRequest();
        this.setIsShowProducts('category');
      } else {
        this.$store.dispatch('searchedProducts', { ...this.getFilterParametrs, q: '' });
      }
    },
    countText: productCount,
    loadPage(direction) { return this.$store.dispatch('searchedProducts', { ...this.$store.getters.productsQuery, page: this.$store.getters.productsPage + direction }); },
    removeFilter(chip) {
      const filters = { ...this.getFilterParametrs };
      if (chip.key === 'price') { delete filters.price_from; delete filters.price_to; }
      else { filters.category_ids = (filters.category_ids || []).filter(id => String(id) !== String(chip.id)); }
      this.$store.commit('setFilterParametrs', filters);
      this.setCheckedCategory(null);
      return this.$store.dispatch('searchedProducts', { ...filters, q: this.searchLocalText });
    },
    ...mapMutations([
      "setIsShowProducts",
      "setIsOpenProductInfo",
      "setAddPerCategory",
      "setChangeSearchText",
      "addPerPage",
      "setCheckedCategory",
      "deleteFilterParametr",
      "cancelProductsRequest",
    ]),
    editSearch() {
      this.$refs.searchInput.focus();
      this.$refs.searchInput.select();
    },
    resetFilters() {
      this.deleteFilterParametr();
      this.setCheckedCategory(null);
      this.usedCategories = {};
      this.usedSort = "";
      return this.$store.dispatch("searchedProducts", { q: this.searchLocalText });
    },
    showCategories() {
      this.cancelProductsRequest();
      this.deleteFilterParametr();
      this.setCheckedCategory(null);
      this.searchLocalText = "";
      this.setChangeSearchText("");
      this.usedCategories = {};
      this.usedSort = "";
      this.setIsShowProducts("category");
    },
    retryProducts() {
      if (this.getCheckedCategory?.id && !this.searchLocalText && !Object.keys(this.getFilterParametrs).length) {
        return this.$store.dispatch("getProductsReq", this.getCheckedCategory.id);
      }
      return this.$store.dispatch("searchedProducts", { ...this.getFilterParametrs, q: this.searchLocalText });
    },
    selectSearchCategory(category) {
      this.searchLocalText = '';
      this.setChangeSearchText('');
      this.deleteFilterParametr();
      this.setCheckedCategory(category);
      this.$store.dispatch('getProductsReq', category.id);
    },
    activeProductSearch(query) {
      this.searchLocalText = query;
      this.setChangeSearchText(query);
      if (!this.searchLocalText.trim().length) {
        return;
      }
      try {
        let data = {
          q: this.searchLocalText,
          ...this.getFilterParametrs,
        };
        this.$store.dispatch("searchedProducts", data);
      } catch (error) {
        console.log(error.message);
      }
    },
    goToMainPage() {
      this.cancelProductsRequest();
      this.setChangeSearchText("");
      this.$emit("setIsChangePage", "home");
    },
    isStartSort(sort) {
      this.usedSort = sort.name;
      this.isOpenSortList = false;
      const data = { ...this.getFilterParametrs, sort: sort.value };
      this.$store.commit('setFilterParametrs', data);
      this.$store.dispatch('searchedProducts', { ...data, q: this.searchLocalText });
    },

    setIsOpenFilterPage() {
      this.addPerPage("product");
      this.$emit("setIsChangePage", "filter");
    },

    setClickToHeaderCategory(value) {
      this.setCheckedCategory(value);
      this.usedCategories = value;
      try {
        this.$store.dispatch("getProductsReq", value.id);
      } catch (error) {
        console.log(error.message);
      }
    },

    setClickToCategory(value) {
      this.setCheckedCategory(value);
      if (value?.children?.length) {
        this.cancelProductsRequest();
        this.usedCategories = value;
        this.setAddPerCategory(value.children);
        this.setIsShowProducts("preCategory");
      } else {
        try {
          this.$store.dispatch("getProductsReq", value.id);
        } catch (error) {
          console.log(error.message);
        }
      }
    },
    getFilterCounter(value) {
      return (value.category_ids?.length || 0) + (value.price_from != null || value.price_to != null ? 1 : 0);
    },
    setClickToPreCategories(value) {
      this.setCheckedCategory(value);
      this.$store.dispatch("getProductsReq", value.id);
    },

    setClickToProduct(value) {
      this.$emit("setIsOpenProductPage");
      this.setIsOpenProductInfo(value);
    },

    setIsOpenSortList() {
      this.isOpenSortList = !this.isOpenSortList;
    },
    discountOf(item) {
      const oldPrice = Number(item.price_old);
      const newPrice = Number(item.price);
      if (!oldPrice || !newPrice || oldPrice <= newPrice) return 0;
      return Math.round((1 - newPrice / oldPrice) * 100);
    },
  },
  watch: {
    searchLocalText(newValue) {
      this.setChangeSearchText(newValue);
    },
    preCategories(newValue, oldValue) {
      let val = oldValue;
      val;
      if (this.usedCategories.id !== newValue.id) {
        this.usedCategories = newValue;
      }
    },
  },
};
</script>

<style scoped>
.applied-filters { display: flex; flex-wrap: wrap; gap: 8px; margin: 12px 0; }
.filter-chip { min-height: 44px; padding: 8px 12px; border: 1px solid #b5b9bf; border-radius: 16px; background: #f0f8f8; color: #075a63; cursor: pointer; }
.results-total { width: 100%; font: 500 14px/20px Inter, sans-serif; margin: 8px 0; }
.pagination { display: flex; justify-content: center; align-items: center; gap: 16px; margin: 24px 0; }
.pagination button { min-height: 44px; padding: 8px 12px; border: 1px solid #b5b9bf; background: #fff; border-radius: 8px; color: #075a63; }

.search-empty-state { display: flex; flex-direction: column; align-items: center; gap: 12px; padding: 36px 8px; text-align: center; color: #333; }
.search-empty-state h2 { font: 600 20px/26px Inter, sans-serif; }
.search-empty-state p { font: 14px/20px Inter, sans-serif; }
.search-empty-button { min-height: 44px; padding: 10px 16px; border: 1px solid #16abb8; border-radius: 8px; background: #fff; color: #075a63; font: 600 14px/20px Inter, sans-serif; cursor: pointer; }
.search-empty-button:focus-visible { outline: 2px solid #075a63; outline-offset: 2px; }
.main-background {
  background: #fff;
  padding: 16px;
}
.category-used-title {
  margin-top: 8px;
  color: #333;
  font-family: Inter;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
}
.category-container {
  display: flex;
  flex-wrap: wrap;
  gap: 17px;
  margin-top: 16px;
}

.category-block {
  width: 160px;
  border-radius: 12px;
  border: 2px solid #d2d6db;
  background: #01bace;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.categoty-image {
  width: 100%;
  height: 160px;
  border-radius: 10px 10px 0px 0px;
  border-bottom: 2px solid #d2d6db;
}

.categoty-name-container {
  padding: 4px;
  display: flex;
  text-align: center;
  margin: auto;
}

.categoty-name {
  margin: 0 auto;
  color: #fff;
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
}

.product-block {
  position: relative;
  width: 140px;
  border-radius: 10px;
  border: 2px solid #d2d6db;
  background: #f3f4f6;
  cursor: pointer;
}
.card-discount-badge {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 2;
  background: #e3000f;
  color: #fff;
  font-family: Inter;
  font-size: 11px;
  font-weight: 700;
  line-height: 14px;
  padding: 2px 6px;
  border-radius: 6px;
}
.product-image {
  width: 100%;
  height: 140px;
  border-radius: 8px 8px 0px 0px;
  border-bottom: 2px solid #d2d6db;
}
.product-name-container {
  padding: 7px;
}
.product-name {
  color: #333;
  font-family: Inter;
  font-size: 11px;
  font-weight: 500;
  line-height: 15px;
}
.product-price {
  color: #01bace;
  font-family: Inter;
  font-size: 9px;
  font-weight: 400;
  line-height: 20px;
}

.product-used-title {
  color: #333;
  font-family: Inter;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  margin-top: 24px;
}

.small-filter-button-icon {
  width: 18px;
  height: 18px;
  margin-right: 5px;
  vertical-align: bottom;
}

.sort-filter-container {
  display: flex;
  gap: 10px;
  margin-top: 16px;
}
.small-filter-button {
  color: #707070;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #d2d6db;
  background: #fff;
  cursor: pointer;
}

.product-sort-list-button {
  color: #707070;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #d2d6db;
  background: #fff;
  cursor: pointer;
}
.sort-button-icon {
  vertical-align: bottom;
  width: 18px;
  height: 18px;
}

.main-sort-container {
  position: relative;
}

.sort-items-container {
  position: absolute;
  border: 1px solid #d2d6db;
  background: #fff;
  border-radius: 8px;
  width: 100%;
  min-width: 150px;
  top: 40px;
  padding: 10px;
  max-height: 150px;
  overflow: auto;
}

.sort-items {
  padding: 5px 0;
  color: #707070;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  transition: all 250 ease;
  cursor: pointer;
}

.sort-items:hover {
  background-color: #e1e2e4;
  border-radius: 5px;
}

.used-filter-length {
  color: #01bace;
  font-family: Lato;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  margin-left: 2px;
}

.noresult-screen-full {
  display: flex;
  align-items: center;
  column-gap: 12px;
}

.input-group {
  position: relative;
  display: flex;
  align-items: stretch;
  width: 70%;
}
.search-input-icon {
  position: absolute;
  top: 12px;
  left: 12px;
}

.form-control {
  padding: 8px 15px;
  border: 1px solid #eee;
  line-height: 22px;
  border-radius: 5px;
  font-size: 13px;
  color: #999;
}

input:focus,
input:active,
.form-control:focus,
.form-control:active {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 1px solid #eee;
  color: #777;
}

.search-text {
  background: #f0f0f0 !important;
  padding: 12px;
  border: none;
  color: #000;
  font-family: "Space Grotesk", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  width: 100%;
  padding-left: 50px;
}

.search-text::placeholder {
  color: #707070;
  font-family: "Space Grotesk", sans-serif;
}

.search-iconn:focus-visible,
.search-text:focus {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.search-filter-btn a {
  border-radius: 8px;
  background: #ff4c3b;
  padding: 12px;
  display: inline-block;
}

.search-input-icon {
  position: absolute;
  top: 12px;
  left: 12px;
}

.filter-button-icon {
  width: 24px;
  height: 24px;
  transform: rotate(90deg);
  color: #fff;
}

.filter-button {
  width: 48px;
  height: 48px;
  background: #01bace;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

.filter-category-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  margin-top: 16px;
}
.filter-category-item {
  border-radius: 16px;
  border: 1px solid #b5b9bf;
  color: #333;
  text-align: center;
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
  line-height: 18px;
  background: #fff;
  padding: 7px 10px;
  cursor: pointer;
}

.main-back-button {
  position: relative;
  background: #f0f0f0;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: 48px;
  height: 48px;
}

.main-back-button-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* === Значні покращення для великих екранів (1024px+) === */
@media (min-width: 1024px) {
  .main-background {
    padding: 0;
    max-width: 1400px;
    margin: 0 auto;
  }

  /* Пошук та навігація */
  .noresult-screen-full {
    max-width: 1200px;
    margin: 0 auto 30px auto;
    padding: 0 20px;
    gap: 16px;
  }

  .main-back-button {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    transition: all 0.3s ease;
  }

  .main-back-button:hover {
    background: #e0e0e0;
    transform: scale(1.05);
  }

  .input-group {
    flex: 1;
  }

  .search-text {
    font-size: 20px;
    padding: 16px 16px 16px 60px;
    border-radius: 12px;
  }

  .search-input-icon {
    top: 16px;
    left: 20px;
    width: 24px;
    height: 24px;
  }

  .filter-button {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    transition: all 0.3s ease;
  }

  .filter-button:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(1, 186, 206, 0.3);
  }

  /* Категорії */
  .filter-category-list {
    max-width: 1200px;
    margin: 24px auto;
    padding: 0 20px;
    justify-content: center;
    gap: 16px;
  }

  .filter-category-item {
    font-size: 14px;
    padding: 12px 20px;
    border-radius: 20px;
    transition: all 0.3s ease;
    font-weight: 600;
  }

  .filter-category-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  /* Заголовки */
  .category-used-title,
  .product-used-title {
    max-width: 1400px;
    margin: 30px auto 24px auto;
    padding: 0 20px;
    font-size: 32px;
    font-weight: 700;
  }

  /* Сітка продуктів та категорій */
  .category-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: 20px;
  }

  /* Картки категорій */
  .category-block {
    width: 100%;
    border-radius: 16px;
    transition: all 0.3s ease;
    overflow: hidden;
    border: 2px solid #e5e7eb;
  }

  .category-block:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
    border-color: #01bace;
  }

  .categoty-image {
    height: 240px;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  .category-block:hover .categoty-image {
    transform: scale(1.05);
  }

  .categoty-name-container {
    padding: 20px;
  }

  .categoty-name {
    font-size: 16px;
    line-height: 24px;
  }

  /* Картки продуктів */
  .product-block {
    width: 100%;
    border-radius: 14px;
    transition: all 0.3s ease;
    border: 2px solid #e5e7eb;
    background: #fff;
    overflow: hidden;
  }

  .product-block:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
    border-color: #01bace;
  }

  .product-image {
    height: 200px;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  .product-block:hover .product-image {
    transform: scale(1.05);
  }

  .product-name-container {
    padding: 10px;
    background: #fff;
  }

  .product-name {
    font-size: 13px;
    line-height: 18px;
    margin-bottom: 8px;
    min-height: 40px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .product-price {
    font-size: 16px;
    font-weight: 600;
    color: #01bace;
  }

  /* Фільтри та сортування */
  .sort-filter-container {
    max-width: 1400px;
    margin: 30px auto 24px auto;
    padding: 0 20px;
    gap: 16px;
  }

  .small-filter-button,
  .product-sort-list-button {
    padding: 12px 20px;
    font-size: 16px;
    border-radius: 10px;
    transition: all 0.3s ease;
  }

  .small-filter-button:hover,
  .product-sort-list-button:hover {
    background: #f8f9fa;
    border-color: #01bace;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .sort-items-container {
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    top: 50px;
  }

  .sort-items {
    padding: 12px 16px;
    font-size: 15px;
  }

  .sort-items:hover {
    background-color: #f0f9ff;
  }
}
</style>
